import { render } from "./ConfigurationCard.vue?vue&type=template&id=30c3b238"
import script from "./ConfigurationCard.vue?vue&type=script&lang=js"
export * from "./ConfigurationCard.vue?vue&type=script&lang=js"

import "./ConfigurationCard.vue?vue&type=style&index=0&id=30c3b238&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__